import { getStorageValue, setStorageValue } from '@portal-internet/core';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { useLaMevaLlista } from 'hooks/3catinfo/useLaMevaLlista';
import { useUser } from 'hooks/useUser';
import { useData } from 'hooks/useData';
import { useModal } from 'hooks/3catinfo/useModal';
import { useModulAvis } from 'hooks/useModulAvis';
import { hitAudiencies } from 'components/3catinfo/Audiencies/audiencies-datalayer';
import __isUndefined from 'lodash/isUndefined';
import __isEmpty from 'lodash/isEmpty';
import Boto from 'components/3catinfo/Boto';
import LlistatFirmes from '../../LlistatFirmes';
import Icona from '../../ui/Icona';
import StickyFooter from '../../AreaUsuaris/StickyFooter';
import clsx from 'clsx';
import styles from './onboarding.module.scss';

export default function Component(props) {
    const { onboardingActiu } = props;
    const tipologia = 'NOT_AUTOR';

    const { setModal, removeModal } = useModal();
    const { isModulAvisActive } = useModulAvis();
    const router = useRouter();

    const [showOnboarding, setShowOnboarding] = useState(false);
    const [showFirmes, setShowFirmes] = useState(false);
    const [registreState, setRegistreState] = useState({});
    const [itemsFirmes, setItemsFirmes] = useState(false);
    const [showedOnboarding, setShowedOnboarding] = useState(true);
    const [cookieChecked, setCookieChecked] = useState(false);
    const [translateY, setTranslateY] = useState(0);

    const { data, getDades } = useData();
    const { signUp, signIn, loginState, loginStateTypes, state: userState, name, isAuthenticated } = useUser();

    const {
        addItemToAPI,
        removeItemToAPI,
        itemsLaMevaLlista,
        updateItemsLaMevaLlista,
        itemsLaMevaLlistaCloneRef,
        stickyVisible,
        setStickyVisible
    } = useLaMevaLlista();

    const timeoutShowOnboarding = useRef(null);
    const refOnboarding = useRef(null);
    const itemsLaMevaLlistaRef = useRef(itemsLaMevaLlista);
    const startY = useRef(0);
    const isMountedRef = useRef(true);

    const SHOW_INTERVAL_DAYS = onboardingActiu?.horesCadaQuantEsMostra ? onboardingActiu?.horesCadaQuantEsMostra / 24 : 7;
    const MAX_ONBOARDING = onboardingActiu?.numMaxCopsQueEsMostra || null;
    const CLOSE_THRESHOLD = 120;
    const isTest =
        typeof window !== 'undefined' && window.Cypress && window?.Cypress?.spec?.baseName !== 'Onboarding.test.feature';

    const nomCookie = 'onboarding_3catinfo';

    const estructuraCookieDefault = { day: '2020/01/01', count: 0 };
    const isEmbedOrPopup = router.asPath.includes('/popup/') || router.asPath.includes('/embed/');
    const isRedl = router?.query?.editmode === 'true' || router?.query?.editmode === 'yes';

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
            clearTimeout(timeoutShowOnboarding.current);
        };
    }, []);

    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const getToday = () => {
        const dateObj = new Date();
        return `${dateObj.getUTCFullYear()}/${dateObj.getUTCMonth() + 1}/${dateObj.getUTCDate()}`;
    };

    const saveOnStorage = (values) =>
        setStorageValue(nomCookie, values, {
            path: '/3catinfo',
            domain: '.3cat.cat',
            expires: 7
        });

    const initializeValues = (data) => (__isUndefined(data) ? estructuraCookieDefault : data);

    const isGuestUser = () => {
        if (isAuthenticated === true) return false;
        if (isAuthenticated === false) return true;
        return loginState === loginStateTypes.GUEST;
    };

    useEffect(() => {
        const fetchDayCookieData = async () => {
            const data = await getStorageValue(nomCookie);
            if (!isMountedRef.current) return;
            let value = initializeValues(data);
            const hasPassed7Days = new Date() - new Date(value.day) >= SHOW_INTERVAL_DAYS * 24 * 60 * 60 * 1000;
            setShowedOnboarding(!hasPassed7Days);
            setCookieChecked(true);
        };

        fetchDayCookieData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isRedl) return;
        if (isGuestUser() && cookieChecked && !showedOnboarding) {
            getStorageValue(nomCookie).then((data) => {
                const value = initializeValues(data);
                if (MAX_ONBOARDING === null || value.count < MAX_ONBOARDING) {
                    timeoutShowOnboarding.current = setTimeout(() => {
                        if (isMountedRef.current) {
                            setShowOnboarding(true);
                        }
                    }, 3500);
                }
            });
        }

        return () => clearTimeout(timeoutShowOnboarding.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loginState, isAuthenticated, cookieChecked, showedOnboarding]);

    useEffect(() => {
        const hash = router.asPath.split('#')[1];
        const parsedHash = new URLSearchParams(hash);
        const encodedState = parsedHash.get('state');
        if (encodedState && !router.pathname?.includes('usuaris-redirect')) {
            try {
                const decodedState = decodeURIComponent(encodedState);
                const stateParams = JSON.parse(decodedState);
                setRegistreState(stateParams);
            } catch {
                setRegistreState({});
            }
        }
    }, [router]);

    useEffect(() => {
        if (
            (userState &&
                userState.router === router.pathname &&
                userState.namespace === '[web]onboarding-firmes-login' &&
                userState.onboardingFirmes) ||
            (registreState.router === router.pathname &&
                registreState.namespace === '[web]onboarding-firmes-registre' &&
                registreState.onboardingFirmes)
        ) {
            setShowFirmes(true);
            //router.replace(router.pathname, undefined, { shallow: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userState, registreState]);

    useEffect(() => {
        if (showFirmes) {
            getDades(
                'https://api.3cat.cat/v2/autor?_format=json&origen=frontal&frontal=n324-trescatinf-totesfirme&items_pagina=30&sdom=img&version=2.0&cache=90&https=true&master=yes&perfils_extra=imatges_3catinfo'
            );
        }
       // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [showFirmes]);

    useEffect(() => {
        if (!isMountedRef.current) return;
        setItemsFirmes(data);
        setStickyVisible(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        itemsLaMevaLlistaRef.current = itemsLaMevaLlista;
    }, [itemsLaMevaLlista]);

    const handleTouchStart = (e) => {
        startY.current = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
        const deltaY = e.touches[0].clientY - startY.current;
        if (deltaY > 0) setTranslateY(deltaY);
    };

    const handleTouchEnd = () => {
        if (translateY > CLOSE_THRESHOLD) {
            tancaOnboarding();
        } else {
            setTranslateY(0);
        }
    };

    const tancaOnboarding = () => {
        removeModal();
        setShowOnboarding(false);
        setShowedOnboarding(true);
        setShowFirmes(false);
    };

    const getArrayDiffs = (original = [], updated = []) => ({
        toRemove: original.filter((id) => !updated.includes(id)),
        toAdd: updated.filter((id) => !original.includes(id))
    });

    const onSaveTrigger = async () => {
        tancaOnboarding();

        const original = itemsLaMevaLlistaCloneRef.current[tipologia] || [];
        const updated = itemsLaMevaLlistaRef.current[tipologia] || [];
        const { toRemove, toAdd } = getArrayDiffs(original, updated);

        try {
            for (const item of toRemove) {
                await removeItemToAPI(item, tipologia);
                await sleep(50);
            }
            for (const item of toAdd) {
                await addItemToAPI(item, tipologia);
                await sleep(50);
            }

            itemsLaMevaLlistaCloneRef.current[tipologia] = [...updated];
            setStickyVisible(false);
            router.push('/3catinfo/meu3catinfo/firmes/');
        } catch (error) {
            console.error('Error actualitzant seleccions:', error);
        }
    };

    const onCancelTrigger = () => {
        updateItemsLaMevaLlista(itemsLaMevaLlistaCloneRef.current);
        setStickyVisible(false);
        tancaOnboarding();
    };

    const stylesOnboardingFirmes = clsx({
        [styles.onBoarding]: true,
        [styles.onBoardingFirmes]: true
    });

    const stylesLlistatAutors = clsx({
        [styles.llistatWrapper]: true,
        [styles.stickyShow]: !!stickyVisible
    });

    const stylesOnboardingLogin = clsx({
        [styles.onBoarding]: true,
        [styles.onBoardingLogin]: true
    });

    const contentOnBoardingFirmes = () => (
        <div ref={refOnboarding} className={styles.mask} role='dialog' aria-modal='true' aria-labelledby='onboarding-titol'>
            <div className={stylesOnboardingFirmes}>
                <button className={styles.botoTanca} onClick={tancaOnboarding}>
                    <Icona icona='tanca' alt='Tanca popup "Crea un compte i personalitza la teva experiència"' />
                </button>

                <div
                    className={styles.rectangleWrapper}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <span className={styles.rectangle}></span>
                </div>

                <div className={styles.onBoardingContent}>
                    <div className={styles.textWrapper}>
                        <div className={styles.nomWrapper}>
                            Hola, <span className={styles.nom}>{name}</span>
                        </div>

                        <div className={styles.descripcio}>
                            Tria les firmes que t&apos;interessen i podràs seguir-les a &quot;El meu 3CatInfo&quot;
                        </div>
                    </div>
                    <div className={stylesLlistatAutors}>
                        <LlistatFirmes
                            numColumns={1}
                            estilMosaic='firmesOnboarding'
                            estilAutor='onboarding'
                            className={styles.mosaicFirmes}
                            items={itemsFirmes}
                            obreEsquerra={true}
                            originUsuaris={true}
                            enviaApi={false}
                        />
                    </div>
                </div>

                {itemsLaMevaLlistaCloneRef.current && (
                    <StickyFooter
                        estil='onBoardingFirmes'
                        tipologia={tipologia}
                        onUpdate={onSaveTrigger}
                        onCancel={onCancelTrigger}
                        isOnModal
                    />
                )}
                {!stickyVisible && (
                    <div className={styles.mesTardContent}>
                        <span role='button' className={styles.mesTard} onClick={() => tancaOnboarding()}>
                            Fes-ho més tard
                        </span>
                    </div>
                )}
            </div>
        </div>
    );

    const contentOnBoarding = () => (
        <div
            data-testid={`onboarding-firmes`}
            ref={refOnboarding}
            className={styles.mask}
            role='dialog'
            aria-modal='true'
            aria-labelledby='onboarding-titol'
        >
            <div className={stylesOnboardingLogin}>
                <div
                    className={styles.rectangleWrapper}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <span className={styles.rectangle}></span>
                </div>

                <div className={styles.contentWrapper}>
                    <div className={styles.firmes}></div>
                    <div className={styles.content}>
                        <div className={styles.contentText}>
                            <h2 className={styles.titol} id='onboarding-titol'>
                                Segueix les firmes <span className={styles.breakTitol}>de 3CatInfo</span>
                            </h2>
                            <p className={styles.text}>
                                Amb el teu compte 3Cat pots tenir tots els articles dels periodistes que més t&apos;interessen a
                                <span className={styles.breakTarget}>&quot;El meu 3CatInfo&quot;</span>
                            </p>
                        </div>
                        <div className={styles.buttons}>
                            {' '}
                            <div className={styles.buttonsContent}>
                                <Boto
                                    tag='button'
                                    text='Inicia sessió'
                                    estil='ple3cat100'
                                    className={styles.boto}
                                    onClick={() => {
                                        hitAudiencies('scClicBoto', {
                                            URL: window.location.href,
                                            identificadorClic: `Modal login 3catinfo - botó login`
                                        });
                                        signUp({ onboardingFirmes: true, namespace: '[web]onboarding-firmes-login' });
                                    }}
                                />

                                <Boto
                                    tag='button'
                                    estil='lined3cat100'
                                    className={styles.boto}
                                    text='Crea el teu compte 3Cat'
                                    onClick={() => {
                                        hitAudiencies('scClicBoto', {
                                            URL: window.location.href,
                                            identificadorClic: `Modal login 3catinfo - botó registre`
                                        });
                                        signIn({
                                            onboardingFirmes: true,
                                            namespace: '[web]onboarding-firmes-registre',
                                            router: router.pathname
                                        });
                                    }}
                                />
                            </div>
                            <div>
                                <span role='button' className={styles.mesTard} onClick={() => tancaOnboarding()}>
                                    Fes-ho més tard
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    useEffect(() => {
        const isOpen = showOnboarding || showFirmes;
        if (isRedl) return;
        if (isOpen) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }

        return () => {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOnboarding, showFirmes]);

    useEffect(() => {
        if (showOnboarding && !isRedl && !isTest && !showedOnboarding && !isEmbedOrPopup && !isModulAvisActive) {
            setModal(contentOnBoarding());
            getStorageValue(nomCookie).then((data) => {
                const value = initializeValues(data);
                const today = getToday();

                if (value.day !== today) {
                    value.day = today;
                    value.count = (value.count || 0) + 1;
                    saveOnStorage(value);
                }
            });
        } else if (showFirmes && !isRedl) {
            setModal(contentOnBoardingFirmes());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showOnboarding, showFirmes, showedOnboarding, isEmbedOrPopup, itemsFirmes, stickyVisible, isModulAvisActive]);

    return null;
}
